export function buildAlarmSettingsRoutes(tenantId: string, siteId: string) {
  const base = `/tenants/${tenantId}/alarm-settings/${siteId}`;
  return {
    root: base,
    manageRoutines: `${base}/manage-routines`,
    changeRoutine: `${base}/change-routine`,
    editRoutine: `${base}/edit-routine`,
    manageExceptions: `${base}/manage-exceptions`,
    createException: `${base}/create-exception`,
    editException: `${base}/edit-exception`,
    editExceptionDetails: `${base}/edit-exception-details`,
    manageAlarmResponse: `${base}/manage-alarm-response`,
    manageNotifications: `${base}/manage-notifications`,
    overrideSite: `${base}/override-site`,
  };
}
